// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { darkThemePalette } from 'theme/defaultThemes';
import { BrandingConfiguration } from '../theme.types';
import { defaultBranding } from './default';
import { createTheme } from '@fluentui/react';
import catMediaHolidays from '../../assets/catmediaholidays.svg';

const winterLightTheme = createTheme({
  palette: {
    themePrimary: '#1c9dff',
    themeLighterAlt: '#f6fbff',
    themeLighter: '#dbefff',
    themeLight: '#c7e0f4',
    themeTertiary: '#71afe5',
    themeSecondary: '#2b88d8',
    themeDarkAlt: '#106ebe',
    themeDark: '#59b0f7',
    themeDarker: '#004578',
    neutralLighterAlt: '#e5f1f7',
    neutralLighter: '#cce2ef',
    neutralLight: '#b2d4e6',
    neutralQuaternaryAlt: '#98c6de',
    neutralQuaternary: '#7eb7d6',
    neutralTertiaryAlt: '#65a9ce',
    neutralTertiary: '#4b9ac5',
    // neutralSecondary: '#318cbd',
    // neutralPrimaryAlt: '#3b3a39',
    // neutralPrimary: '#318cbd',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff'
  },
  semanticColors: {
    errorText: '#a80000',
    primaryButtonBackgroundDisabled: 'rgb(243, 242, 241)',
    primaryButtonTextDisabled: 'rgb(161, 159, 157)',
    buttonTextDisabled: 'rgb(161, 159, 157)'
  }
});

export const winterBranding: BrandingConfiguration = {
  ...defaultBranding,
  startDate: new Date(2000, 11, 1),
  endDate: new Date(2001, 11, 31),
  welcomeMessages: {
    morning: 'Happy Holidays',
    afternoon: 'Happy Holidays',
    evening: 'Happy Holidays',
    night: 'Ho ho ho'
  },
  fluentTheme: {
    Light: winterLightTheme,
    Dark: darkThemePalette
  },
  catImage: catMediaHolidays.toString(),
  customBranding: {
    // TODO: add dark and light here
    // backgroundImage: {
    //   url: '/dark-winter.jpg'
    // }
  },
  lobbySoundUrl: '/audios/winter/dreams.mp3',
  videoBackgrounds: [
    {
      key: 'Fireplace',
      url: '/backgrounds/fireplace.png',
      tooltipText: 'Fireplace'
    },
    {
      key: 'IceRink',
      url: '/backgrounds/ice-rink.png',
      tooltipText: 'Ice Rink'
    },
    {
      key: 'SkiSlope',
      url: '/backgrounds/ski-slope.png',
      tooltipText: 'Ski Slope'
    },
    {
      key: 'SnowFun',
      url: '/backgrounds/snow-fun.png',
      tooltipText: 'Snow Fun'
    },
    ...defaultBranding.videoBackgrounds
  ],
  landingPageEffect: 'snow',
  noMeetingsEmoji: '🎄'
};
